const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * UserAssessments Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('UserAssessments', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/user-assessments/:subresource/:subname/:subsubresource/:subsubname', null, {
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    findOne: {params: {subresource: ''}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    reset: {params: {subname: 'attempts-reset'}, method: 'POST', isArray: false},
    createAndScore: {params: {subresource: 'create-and-score'}, method: 'POST', isArray: false},
    score: {params: {subresource: 'score'}, method: 'POST', isArray: false},
    manualScore: {params: {subresource: 'score', subsubresource: 'manual'}, method: 'POST', isArray: false},
    searchUsers: {params: {subresource: 'search-users'}, method: 'POST', isArray: true}
  });
}]);